/* eslint-disable @typescript-eslint/naming-convention */
import { FileUploadPayloadType } from '@astronautsid/wpe-utils'

import AxiosInstance from 'config/apiServiceApiGateway'
import { ServiceInternalFileRules, ServiceInternalFileUpload } from 'config/apiServiceFile'
import {
  VendorDetailsInterface,
  VendorCompanyType,
  VendorOptionsResponseType,
  VendorUomsResponseType,
  AstroPicResponseType,
  VMSDocsIdType,
  VendorSubmissionPayloadType,
} from '../types/VendorManagement'
import { rolesIdQuery, rolesQuery } from '../constants/picParams'

export type GetBrandListParamsType = {
  'pagination.page_size': number
  'pagination.page_index': number
  sort: string
  direction: string
  name?: string
}

export type GetBrandListResponseType = {
  data: BrandItemType[]
  pagination: {
    sort: string
    direction: string
    page_size: number
    page_index: number
    number_of_elements: number
  }
}

export type BrandItemType = {
  brand_id: number
  brand_name: string
  cloud_kitchen?: boolean
  brand_company?: BrandCompanyItemType
  created_by?: string
}

export type BrandCompanyItemType = {
  id: number
  name: string
  active?: boolean
  created_at?: string
  created_by?: string
  updated_at?: string
  updated_by?: string
}

export const getVendorDetails = (id: string) =>
  AxiosInstance.Get<{ data: VendorDetailsInterface; error: { status: boolean } }, true>({
    url: '/commercial/internal/:version/vendors/:id?with_astro_pic=true&with_shipping_info=true',
    version: 'v1',
    urlParams: { id },
  })

export const getCompanies = () =>
  AxiosInstance.Get<VendorCompanyType[]>({
    url: `/commercial/internal/:version/companies?page_size=99`,
    version: 'v1',
  })

export const postVendorRequest = (data: VendorSubmissionPayloadType) =>
  AxiosInstance.Post({
    url: `/commercial/internal/:version/vendors/submissions`,
    version: 'v1',
    data,
  })

export const postReview = (vendor_id: number | string, data: { action: string; reason: string }) =>
  AxiosInstance.Post({
    url: `/commercial/internal/:version/vendors/submissions/${vendor_id}/review`,
    version: 'v1',
    data,
  })

export const getOptions = () =>
  AxiosInstance.Get<VendorOptionsResponseType, true>({
    url: `/commercial/internal/:version/options/vendor`,
    version: 'v1',
  })

type GetUomsOptionsType = {
  isShown?: boolean
}

export const getUoms = (options?: GetUomsOptionsType) =>
  AxiosInstance.Get<VendorUomsResponseType, true>({
    url: `/commercial/internal/:version/uoms`,
    version: 'v1',
    ...(options?.isShown === undefined ? {} : { params: { is_shown: options.isShown } }),
  })

export const getPicList = (email: string) =>
  AxiosInstance.Get<AstroPicResponseType, true>({
    url: `/accounts/internal/:version/user/location/role?page_index=0&page_size=10&${rolesQuery}&${rolesIdQuery}&email=${email}`,
    version: 'v1',
  })

export const postUploadDocumentsFile = (payload: FileUploadPayloadType[]) =>
  ServiceInternalFileUpload(payload)

export const getVendorDocumentsFileRulesAPI = (typeId: VMSDocsIdType) =>
  ServiceInternalFileRules(typeId)

export const getDocFileUrlAPI = (fileUrl: string, type: string, typeId: VMSDocsIdType) =>
  AxiosInstance.Get<Blob, true>({
    url: `/internal/:version/${typeId}/download`,
    version: 'v1',
    params: { fileUrl },
    config: {
      baseURL: process.env.REACT_APP_BASE_URL_API_FILE_SERVICE,
      responseType: 'blob',
      transformResponse: (data) => new Blob([data], { type }),
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Service-Name': 'astro-app-web-admin',
      },
    },
  })

// this is the same as getBrandList in src/features/Enterprise/Brand/services/brandService.ts
// but we duplicate it here to make it decoupled from the Brand feature
export const getBrandList = (params: GetBrandListParamsType) =>
  AxiosInstance.Get<GetBrandListResponseType, true>({
    url: '/ims/internal/v1/brands',
    params,
  })
